import {
    Box,
    Button,
    Grid,
    InputAdornment,
    TextField,
} from "@material-ui/core";
import {useWatch} from "react-hook-form";
import React, {useState} from "react";
import {modal} from "../../../../util";
import styled from "styled-components";

const A = styled.a`
  color: #306F9D;
  text-decoration: none;
`;

export default function SlideImage(props) {
    const {
        index,
        control,
        Controller,
        classes,
        defaultValues,
        setValue,
        getValues,
        lang,
        handleFileUpload,
        disabled,
    } = props;

    useWatch({
        control,
        name: "slides",
    });

    const [currImageEn, setCurrImageEn] = useState(
        getValues(`slides.${index}.localizations.en.image`)
    );
    const [currImageTc, setCurrImageTc] = useState(
        getValues(`slides.${index}.localizations.tc.image`)
    );
    const [isImageChanged, setIsImageChanged] = useState({
        tc: [],
        en: []
    });

    return (
        <Grid container item xs={12}>
            <Box>
                <h4>
                    <small>Image</small>
                </h4>
            </Box>
            <Grid
                container
                item
                xs={12}
                style={lang() === "tc" ? {display: "none"} : {}}
            >
                <TextField
                    htmlFor={`raised-button-file-${index}`}
                    label={
                        getValues(`slides.${index}.localizations.en.image`)
                            ? currImageEn
                                ? "Change Image"
                                : "Upload Image"
                            : ""
                    }
                    className={classes.fileInput}
                    value=""
                    variant="outlined"
                    placeholder={currImageEn ? "Change Image" : "Upload Image"}
                    fullWidth
                    InputProps={{
                        classes: {
                            input: classes["&::placeholder"],
                        },
                        endAdornment: (
                            <Controller
                                control={control}
                                name={`slides.${index}.localizations.en.image`}
                                defaultValue={defaultValues[index] ? defaultValues[index].localizations.en.image : ""}
                                render={({field}) => {
                                    return (
                                        <InputAdornment
                                            position="end">
                                            <input
                                                style={{display: "none"}}
                                                id={`raised-button-file-${index}`}
                                                type="file"
                                                onChange={(e) => {
                                                    handleFileUpload(index, e);
                                                    setIsImageChanged({
                                                        ...isImageChanged,
                                                        en: [...isImageChanged.en, index],
                                                    });
                                                }}
                                            />
                                            <Button
                                                htmlFor={`raised-button-file-${index}`}
                                                variant="outlined"
                                                component="label"
                                                size="small"
                                            >
                                                Choose
                                            </Button>
                                        </InputAdornment>
                                    );
                                }}
                            />
                        ),
                    }}
                    style={currImageEn ? {marginBottom: "0"} : {}}
                />

                {getValues(`slides.${index}.localizations.en.image`) || currImageEn ? (
                    <p>
                        <img
                            src={
                                getValues(`slides.${index}.localizations.en.image`) ||
                                currImageEn
                            }
                            style={{
                                maxHeight: "30px",
                                maxWidth: "30px",
                                cursor: "pointer"
                            }}
                            alt=""
                            onClick={() => window.open(getValues(`slides.${index}.localizations.en.image`) ||
                                currImageEn, '_blank').focus()}
                        />
                        &nbsp;
                        <A href={getValues(`slides.${index}.localizations.en.image`) ||
                            currImageEn} target="_blank">
                            <small>
                                {getValues(`slides.${index}.localizations.en.image`)
                                    ? getValues(`slides.${index}.localizations.en.image`)
                                        .split("/")
                                        .pop()
                                    : currImageEn.split("/").pop()}
                            </small></A>
                        {disabled || (
                            <small
                                style={{
                                    marginLeft: "20px",
                                    textDecoration: "underline",
                                    color: "#962013",
                                    cursor: "pointer",
                                }}
                                onClick={async () => {
                                    const decision = await modal.fire({
                                        title: "Delete Image",
                                        text: "Are you sure to delete this image?",
                                        showCancelButton: true,
                                        confirmButtonText: `Delete`,
                                    });
                                    if (decision.isConfirmed) {
                                        setCurrImageEn("");
                                        setValue(`slides.${index}.localizations.en.image`, "");
                                    }
                                }}
                            >
                                Delete
                            </small>
                        )}
                    </p>
                ) : (
                    ""
                )}
            </Grid>

            <Grid
                container
                item
                xs={12}
                style={lang() === "en" ? {display: "none"} : {}}
            >
                <TextField
                    htmlFor={`raised-button-file-${index}`}
                    label={
                        getValues(`slides.${index}.localizations.tc.image`)
                            ? currImageTc
                                ? "Change Image"
                                : "Upload Image"
                            : ""
                    }
                    className={classes.fileInput}
                    value=""
                    variant="outlined"
                    placeholder={currImageTc ? "Change Image" : "Upload Image"}
                    fullWidth
                    InputProps={{
                        classes: {
                            input: classes["&::placeholder"],
                        },
                        endAdornment: (
                            <Controller
                                control={control}
                                name={`slides.${index}.localizations.tc.image`}
                                defaultValue={defaultValues[index] ? defaultValues[index].localizations.tc.image : ""}
                                render={({field}) => {
                                    return (
                                        <InputAdornment
                                            position="end">
                                            <input
                                                style={{display: "none"}}
                                                id={`raised-button-file-${index}`}
                                                type="file"
                                                onChange={(e) => {
                                                    handleFileUpload(index, e);
                                                    setIsImageChanged({
                                                        ...isImageChanged,
                                                        tc: [...isImageChanged.tc, index],
                                                    });
                                                }}
                                            />
                                            <Button
                                                htmlFor={`raised-button-file-${index}`}
                                                variant="outlined"
                                                component="label"
                                                size="small"
                                            >
                                                Choose
                                            </Button>
                                        </InputAdornment>
                                    );
                                }}
                            />
                        ),
                    }}
                    style={currImageTc ? {marginBottom: "0"} : {}}
                />

                {getValues(`slides.${index}.localizations.tc.image`) || currImageTc ? (
                    <p>
                        <img
                            src={
                                getValues(`slides.${index}.localizations.tc.image`) ||
                                currImageTc
                            }
                            style={{
                                maxHeight: "30px",
                                maxWidth: "30px",
                                cursor: "pointer"
                            }}
                            alt=""
                            onClick={() => window.open(getValues(`slides.${index}.localizations.tc.image`) ||
                                currImageTc, '_blank').focus()}
                        />
                        &nbsp;
                        <A href={getValues(`slides.${index}.localizations.en.image`) ||
                            currImageEn} target="_blank">
                            <small>
                                {getValues(`slides.${index}.localizations.tc.image`)
                                    ? getValues(`slides.${index}.localizations.tc.image`)
                                        .split("/")
                                        .pop()
                                    : currImageTc.split("/").pop()}
                            </small>
                        </A>
                        {disabled || (
                            <small
                                style={{
                                    marginLeft: "20px",
                                    textDecoration: "underline",
                                    color: "#962013",
                                    cursor: "pointer",
                                }}
                                onClick={async () => {
                                    const decision = await modal.fire({
                                        title: "Delete Image",
                                        text: "Are you sure to delete this image?",
                                        showCancelButton: true,
                                        confirmButtonText: `Delete`,
                                    });
                                    if (decision.isConfirmed) {
                                        setCurrImageTc("");
                                        setValue(`slides.${index}.localizations.tc.image`, "");
                                    }
                                }}
                            >
                                Delete
                            </small>
                        )}
                    </p>
                ) : (
                    ""
                )}
            </Grid>
        </Grid>
    );
}
